// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SmsPackResponse

export type SmsPackApiResponse = {
	credits: number;
	price: number;
};

export type SmsPack = {
	credits: number;
	price: number;
};

export function hydrateSmsPack(data: SmsPackApiResponse): SmsPack {
	return { ...data };
}